import { Control, Controller } from "react-hook-form"
import { IDataCollectionStandardConfig } from "@piceasoft/core"
import PhoneNumber from "./PhoneNumber"
import {getMaskedFieldRules} from "../../../helpers/validationRules" 

import type { TContractData } from "../../../../../dataCollectionTypes"

type TProps = {
    fieldValue?: string
    config?: IDataCollectionStandardConfig
    errorMessage: string
    phoneCountry?: string
    control: Control<TContractData, object>
}

const PhoneNumberController: React.FunctionComponent<TProps> = (props) => {
    let {config, control, fieldValue, phoneCountry, errorMessage} = props
    return (
        <Controller
            name="phone"
            control={control}
            rules={getMaskedFieldRules(fieldValue)}
            render={({ field }) =>
                <PhoneNumber
                    config={config}
                    value={field.value}
                    phoneCountry={phoneCountry}
                    errorMessage={errorMessage}
                    handleOnBlur={field.onBlur}
                    handleOnChange={(value: string) => {
                        field.onChange(value)
                    }}
                />
            }
        />
    )
}

export default PhoneNumberController